module.exports = __webpack_public_path__ + "img/politicas.55ab5969.png";